// Import Components
import Form from './../../components/forms/Form.vue'
import gxDialog from './../../components/forms/gxDialog.vue'

export default {
  Form, gxDialog
}
